// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-ce006dc8] {\r\n  font-size: 1.714rem !important;\r\n  font-weight: 500;\n}\n[dir] label[data-v-ce006dc8] {\r\n  margin-bottom: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
